"use client";

import * as React from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";

/**
 * Dark is the default (product plan section 0.1) — `defaultTheme="dark"`,
 * with `enableSystem={false}` so a visitor's OS setting never silently
 * overrides that decision; the explicit toggle (`ThemeToggle`) is the only
 * way to switch. `next-themes` toggles the `.light`/`.dark` class the
 * globals.css tokens key off of.
 */
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="dark"
      enableSystem={false}
      themes={["dark", "light"]}
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}
